import React from 'react'
import PropTypes from 'prop-types'

import Utils from 'Utils'

import { Row, Text } from 'Components/UI'

function InvitedByCell({ value: { profile } }) {
  return (
    <Row center>
      <Text breakWord header header4>
        {Utils.User.getFullName(profile)}
      </Text>
    </Row>
  )
}

InvitedByCell.defaultProps = {
  value: {},
}

InvitedByCell.propTypes = {
  value: PropTypes.object,
}

export default InvitedByCell
